/**
 * Feature item value type values
 */
export enum FeatureItemValueTypeEnum {
	NUMBER = 'number',
	BOOL = 'bool',
	STRING = 'string',
	JSON = 'json',
}
